import React from 'react';
import { useTranslation } from 'react-i18next';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { Button } from '@mui/material';
import useStyles from './styles';

export default function ActualWorkshopsPopupButton(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { handleClickOpen } = props;

  return (
    <Button className={classes.addButton} onClick={handleClickOpen}>
      <AddCircleIcon />
      {t('add_new_workshops')}
    </Button>
  );
}
